export const baseUrl = process.env.REACT_APP_API_HOST;
export { loginPost } from "./auth/auth";
export * from "./cart/cart";
export * from "./products/products";
